import { TableActions } from '@core/components/Table';
import { permissaoUtils } from '@core/util/permissaoUtil';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { useContext } from 'react';
import { FaPlus } from 'react-icons/fa';
import { ServicoContext } from '../../ServicoContext';
import { servicoModais } from '../modal/servicoModais';

const ServicoFab = ({ onDelete }) => {
  const [, setModal] = useContext(ServicoContext).modal;
  const [selecao] = useContext(ServicoContext).selecao;
  const [tipoSelecao] = useContext(ServicoContext).tipoSelecao;
  const [, setServicoAtual] = useContext(ServicoContext).servicoAtual;

  const existeSelecionados = selecao.length > 0 || tipoSelecao !== 'NENHUM';

  const triggerCreate = (modal) => {
    setServicoAtual({});
    setModal(modal);
  };

  const triggerDelete = () => {
    const idsSelecionados = selecao.map((obj) => obj.id);
    onDelete(idsSelecionados);
  };

  const actions = [
    {
      icon: <DeleteIcon />,
      name: 'delete',
      tooltip: 'Excluir',
      show: permissaoUtils.servico().excluir && existeSelecionados,
      onClick: triggerDelete,
    },

    {
      icon: <FaPlus />,
      name: 'createServico',
      tooltip: 'Cadastrar',
      show: permissaoUtils.servico().cadastrar,
      onClick: () => triggerCreate(servicoModais.editarServicoModal),
    },
  ];

  return <TableActions className={'stepFabButton'} actions={actions} />;
};

export default ServicoFab;
